import { Project } from '../types';

export const projectsData: Project[] = [
  {
    id: 'p2p-lending',
    title: 'P2P Lending Platform',
    description: 'projects.p2pLending',
    technologies: ['NodeJS', 'NestJS', 'TypeORM', 'PostgreSQL', 'AWS', 'SNS/SQS'],
    link: 'https://zirtue.com',
    github: undefined,
  },
  {
    id: 'fertilizer-platform',
    title: 'Fertilizer–Farmer Connectivity Platform',
    description: 'projects.fertilizerPlatform',
    technologies: ['NodeJS', 'NestJS', 'Prisma', 'PostgreSQL', 'AWS', 'Cloud Architecture'],
    link: 'https://soilsync.bio',
    github: undefined,
  },
  {
    id: 'ai-search-system',
    title: 'AI-powered Search System',
    description: 'projects.aiSearchSystem',
    technologies: ['OpenAI API', 'Qdrant', 'React', 'Node.js', 'Semantic Search', 'Zapier'],
    link: 'https://aithor.com',
    github: undefined,
  },
  {
    id: 'payment-integration',
    title: 'Payment Integration Systems',
    description: 'projects.paymentIntegration',
    technologies: ['Stripe', 'Paddle', 'Auth0', 'React', 'Node.js', 'Payment Processing'],
    link: 'https://smile2impress.com',
    github: undefined,
  },
  {
    id: 'graphql-platform',
    title: 'GraphQL Platform',
    description: 'projects.graphqlPlatform',
    technologies: ['GraphQL', 'Apollo Federation', 'NestJS', 'Node.js', 'Distributed Systems'],
    link: 'https://www.infobip.com',
    github: undefined,
  },
  {
    id: 'parsing-bot-system',
    title: 'Parsing Bot System',
    description: 'projects.parsingBotSystem',
    technologies: ['Selenium', 'Docker', 'Node.js', 'Web Scraping', 'API Design'],
    link: 'https://semrush.com',
    github: undefined,
  },
  {
    id: 'banking-applications',
    title: 'Banking Applications',
    description: 'projects.bankingApplications',
    technologies: ['React', 'React Native', 'Agile', 'Team Leadership', 'Banking Systems'],
    link: 'https://www.alfabank.ru',
    github: undefined,
  },
  {
    id: 'legacy-refactoring',
    title: 'Legacy System Refactoring',
    description: 'projects.legacyRefactoring',
    technologies: ['NestJS', 'Jenkins', 'Legacy Systems', 'Microservices', 'CI/CD'],
    link: 'https://www.infobip.com',
    github: undefined,
  },
  {
    id: 'translation-system',
    title: 'Translation System Integration',
    description: 'projects.translationSystem',
    technologies: ['Smartcat', 'Automation', 'Repository Parsing', 'Translation Management'],
    link: 'https://www.infobip.com',
    github: undefined,
  }
];